import React, { useEffect, useState } from "react";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";

type Props = {
  title: string;
  isLoading: boolean;
  text: {
    batchName: string;
    Timing: string;
    courseName: string;
    teachers: { _id: string; name: string }[];
  };
  onConfirm?: () => void;
  onCancel: () => void;
};

const ProceedDialogBox: React.FC<Props> = ({
  title,
  onConfirm,
  isLoading,
  onCancel,
  text,
}: Props) => {
  const handleSubmit = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const [countdown, setCountdown] = useState(3);
  const [confirmEnabled, setConfirmEnabled] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 1) {
          clearInterval(timer);
          setConfirmEnabled(true);
          return 0;
        } else {
          return prevCountdown - 1;
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="fixed inset-0 bg-black opacity-50"></div>
        <div className="fixed flex flex-col transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg rounded-2xl top-1/2 left-1/2 w-[500px] z-10">
          <p className="p-4 font-semibold text-md text-slate-500">
            Check the details once before confirm
          </p>

          <div className="flex flex-col px-4 divide-y">
            <div className="flex gap-2 py-2">
              <div className="w-[80px]">Batch : </div>
              <div className="font-medium text-md text-slate-700">
                {text?.batchName}
              </div>
            </div>
            <div className="flex gap-2 py-2">
              <div className="w-[80px]">Timing : </div>
              <div className="font-medium text-md text-slate-700">
                {text?.Timing}
              </div>
            </div>
            <div className="flex gap-2 py-2">
              <div className="w-[80px]">Course : </div>
              <div className="font-medium text-md text-slate-700">
                {text?.courseName}
              </div>
            </div>
            <div className="flex gap-2 py-2">
              <div className="w-[80px]">Teachers : </div>
              <div className="font-medium text-md text-slate-700">
                {text?.teachers?.map((teacher) => teacher?.name)?.join(", ")}
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-3 p-4">
            <button
              onClick={onCancel}
              className="px-4 py-2 text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none"
            >
              Cancel
            </button>
            <ATMLoadingButton
              onClick={handleSubmit}
              className={`px-4 py-2 text-white bg-green-500 rounded hover:bg-green-600 focus:outline-none disabled:bg-gray-200 disabled:text-slate-500 ${
                confirmEnabled ? "w-24" : "w-[115px]"
              }`}
              disabled={!confirmEnabled || isLoading}
              isLoading={isLoading}
            >
              {confirmEnabled ? "Confirm" : `Confirm (${countdown})`}
            </ATMLoadingButton>

            {/* <button
              onClick={handleSubmit}
              className="px-4 py-2 text-white bg-green-500 rounded hover:bg-green-600 focus:outline-none disabled:bg-gray-200 disabled:text-slate-500"
              disabled={!confirmEnabled}
            >
              {confirmEnabled ? "Confirm" : `Confirm (${countdown})`}
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProceedDialogBox;
